const componentStyles = (_theme) => ({
  header: {
    background: "#ECF0F1",
  },
});

export default componentStyles;
